//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    title: {
      type: String,
      default: ' '
    }
  },
  data: function data() {
    return {
      time: ''
    };
  },
  created: function created() {
    this.timeUpdate();
  },
  methods: {
    timeUpdate: function timeUpdate() {
      var _this = this;
      setInterval(function () {
        _this.time = _this.$util.parseTime(new Date(), '{h}:{i}');
      }, 1000);
    }
  }
};